var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0001 16.6198V17.9998C32.9982 21.2344 31.9508 24.3818 30.014 26.9725C28.0773 29.5633 25.355 31.4585 22.2531 32.3756C19.1512 33.2928 15.8359 33.1826 12.8017 32.0617C9.76753 30.9407 7.17699 28.8689 5.41644 26.1554C3.6559 23.4418 2.81969 20.2319 3.03252 17.0043C3.24534 13.7766 4.49581 10.7043 6.59743 8.24541C8.69904 5.78653 11.5392 4.07287 14.6943 3.36002C17.8494 2.64716 21.1504 2.9733 24.105 4.2898",
    stroke: "#45941E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 6L18 21.015L13.5 16.515",
    stroke: "#45941E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.9e0a18c77a4fbda7687ca793bd67cad4.svg";
export { ForwardRef as ReactComponent };